import { MCBQS060SearchRequest } from "types/MCBQS060/MCBQS060SearchRequest";
import { MCBQS060PdfDownloadRequest } from "types/MCBQS060/MCBQS060PdfDownloadRequest";
import request from "utils/request";
import { MCBQS060ViewErrorCheckModalRequest } from "types/MCBQS060/MCBQS060ViewErrorCheckModalRequest";
import { MCBQS060TransitionSubmissionRequestListRequest } from "types/MCBQS060/MCBQS060TransitionSubmissionRequestListRequest";
import { MCBQS060DeletePdfDownloadRecordRequest } from "types/MCBQS060/MCBQS060DeletePdfDownloadRecordRequest";

export const mCBQS060InitRequest = (apidata: MCBQS060SearchRequest) =>
  request({
    url: `/MCBQS060/init`,
    method: 'post',
    data: apidata,
  })

export const mCBQS060FindRequest = (apidata: MCBQS060SearchRequest) =>
  request({
    url: `/MCBQS060/find`,
    method: 'post',
    data: apidata,
  })

export const outputSetPdfRequest = (apidata: MCBQS060PdfDownloadRequest) =>
  request({
    url: `/MCBQS060/clickTitleLink`,
    method: 'post',
    responseType: 'blob',
    data: apidata,
  })

export const mCBQS060ErrorConfirmRequest = (apidata: MCBQS060ViewErrorCheckModalRequest) =>
  request({
    url: `/MCBQS060/clickErrorConfirmButton`,
    method: 'post',
    data: apidata,
  })

export const mCBQS060TranstionRequest = (apidata: MCBQS060TransitionSubmissionRequestListRequest) =>
  request({
    url: `/MCBQS060/clickNumbeOfSubmissionsLink`,
    method: 'post',
    data: apidata,
  })

export const mCBQS060DeleteRequest = (apidata: MCBQS060DeletePdfDownloadRecordRequest) => 
  request({
    url: `/MCBQS060/clickDeleteButton`,
    method: 'post',
    data: apidata,
  })